module.exports = __webpack_public_path__ + "static/media/geth-bg.502dad1b.png";